export const AGENCY_METHODS = [
  { value: 'portal', label: 'Portal' },
  { value: 'phone', label: 'Phone' },
  { value: 'email', label: 'Email' },
  { value: 'form', label: 'Form' },
  { value: 'in_person', label: 'In person' },
  { value: 'sms', label: 'SMS' },
  { value: 'letter', label: 'Letter' },
  { value: 'other', label: 'Other' },
];

export const AGENCY_KINDS = [
  { value: 'wc_48h', label: 'iCare Workers Compensation', agency: 'icare' },
  { value: 'safework_immediate', label: 'SafeWork Immediate', agency: 'safework' },
  { value: 'safework_written', label: 'SafeWork Written (48h)', agency: 'safework' },
  { value: 'ndis_24h', label: 'NDIS 24 hours', agency: 'ndis' },
  { value: 'ndis_5day', label: 'NDIS 5 business days', agency: 'ndis' },
  { value: 'ndis_rp_monthly', label: 'NDIS restrictive practice monthly', agency: 'ndis' },
  { value: 'ndis_rp_fortnightly', label: 'NDIS restrictive practice fortnightly', agency: 'ndis' },
  { value: 'ndis_urp_5_business_days', label: 'NDIS unauthorised restrictive practice (5 business days)', agency: 'ndis' },
  { value: 'ndis_urp_24_hours', label: 'NDIS unauthorised restrictive practice (24 hours)', agency: 'ndis' },
  { value: 'ndis_incident_5_day_followup', label: 'NDIS 5-day follow-up', agency: 'ndis' },
  { value: 'ndis_urp_weekly_followup', label: 'NDIS weekly unauthorised follow-up', agency: 'ndis' },
  { value: 'ndis_rp_review', label: 'NDIS restrictive practice review', agency: 'ndis' },
  { value: 'police', label: 'Police', agency: 'police' },
  { value: 'ambulance', label: 'Ambulance', agency: 'ambulance' },
  { value: 'fire', label: 'Fire & Rescue', agency: 'fire' },
  { value: 'child_protection', label: 'Child protection', agency: 'child_protection' },
  { value: 'hospital', label: 'Hospital', agency: 'hospital' },
  { value: 'other', label: 'Other', agency: 'other' },
];

export const AGENCY_GROUPS = [
  {
    value: 'icare',
    label: 'iCare Workers Compensation',
    defaultName: 'iCare Workers Compensation',
    kinds: [{ value: 'wc_48h', label: '48 hour notification' }],
  },
  {
    value: 'ndis',
    label: 'NDIS',
    defaultName: 'NDIS Commission',
    kinds: [
      { value: 'ndis_24h', label: '24 hours' },
      { value: 'ndis_5day', label: '5 business days' },
      { value: 'ndis_rp_monthly', label: 'Restrictive practice monthly' },
      { value: 'ndis_rp_fortnightly', label: 'Restrictive practice fortnightly' },
      { value: 'ndis_urp_5_business_days', label: 'Unauthorised restrictive practice (5 business days)' },
      { value: 'ndis_urp_24_hours', label: 'Unauthorised restrictive practice (24 hours)' },
      { value: 'ndis_incident_5_day_followup', label: '5-day follow-up' },
      { value: 'ndis_urp_weekly_followup', label: 'Weekly unauthorised follow-up' },
      { value: 'ndis_rp_review', label: 'Restrictive practice review' },
    ],
  },
  {
    value: 'safework',
    label: 'SafeWork',
    defaultName: 'SafeWork',
    kinds: [
      { value: 'safework_immediate', label: 'Immediate' },
      { value: 'safework_written', label: 'Written (48h)' },
    ],
  },
  { value: 'police', label: 'Police', defaultName: 'Police', kinds: [{ value: 'police', label: 'Police' }] },
  { value: 'ambulance', label: 'Ambulance', defaultName: 'Ambulance', kinds: [{ value: 'ambulance', label: 'Ambulance' }] },
  { value: 'fire', label: 'Fire & Rescue', defaultName: 'Fire & Rescue', kinds: [{ value: 'fire', label: 'Fire & Rescue' }] },
  { value: 'child_protection', label: 'Child protection', defaultName: 'Child Protection', kinds: [{ value: 'child_protection', label: 'Child protection' }] },
  { value: 'hospital', label: 'Hospital', defaultName: 'Hospital', kinds: [{ value: 'hospital', label: 'Hospital' }] },
  { value: 'other', label: 'Other', defaultName: '', kinds: [{ value: 'other', label: 'Other' }] },
];

export const AGENCY_NAME_PRESETS = [
  { value: 'nsw_police', label: 'NSW Police', agency: 'police', kind: 'police' },
  { value: 'vic_police', label: 'Victoria Police', agency: 'police', kind: 'police' },
  { value: 'qld_police', label: 'Queensland Police', agency: 'police', kind: 'police' },
  { value: 'sa_police', label: 'SA Police', agency: 'police', kind: 'police' },
  { value: 'wa_police', label: 'WA Police', agency: 'police', kind: 'police' },
  { value: 'tas_police', label: 'Tasmania Police', agency: 'police', kind: 'police' },
  { value: 'nt_police', label: 'NT Police', agency: 'police', kind: 'police' },
  { value: 'act_police', label: 'ACT Policing', agency: 'police', kind: 'police' },
  { value: 'nsw_ambulance', label: 'NSW Ambulance', agency: 'ambulance', kind: 'ambulance' },
  { value: 'vic_ambulance', label: 'Ambulance Victoria', agency: 'ambulance', kind: 'ambulance' },
  { value: 'qld_ambulance', label: 'Queensland Ambulance Service', agency: 'ambulance', kind: 'ambulance' },
  { value: 'sa_ambulance', label: 'SA Ambulance', agency: 'ambulance', kind: 'ambulance' },
  { value: 'wa_ambulance', label: 'St John WA', agency: 'ambulance', kind: 'ambulance' },
  { value: 'tas_ambulance', label: 'Ambulance Tasmania', agency: 'ambulance', kind: 'ambulance' },
  { value: 'nt_ambulance', label: 'St John NT', agency: 'ambulance', kind: 'ambulance' },
  { value: 'act_ambulance', label: 'ACT Ambulance', agency: 'ambulance', kind: 'ambulance' },
  { value: 'nsw_fire', label: 'Fire and Rescue NSW', agency: 'fire', kind: 'fire' },
  { value: 'vic_fire', label: 'Fire Rescue Victoria', agency: 'fire', kind: 'fire' },
  { value: 'qld_fire', label: 'Queensland Fire and Emergency Services', agency: 'fire', kind: 'fire' },
  { value: 'sa_fire', label: 'SAMFS', agency: 'fire', kind: 'fire' },
  { value: 'wa_fire', label: 'DFES WA', agency: 'fire', kind: 'fire' },
  { value: 'ndis_commission', label: 'NDIS Commission', agency: 'ndis', kind: 'ndis_24h' },
  { value: 'safework_nsw', label: 'SafeWork NSW', agency: 'safework', kind: 'safework_immediate' },
  { value: 'worksafe_vic', label: 'WorkSafe Victoria', agency: 'safework', kind: 'safework_immediate' },
  { value: 'whsq', label: 'Workplace Health and Safety Queensland', agency: 'safework', kind: 'safework_immediate' },
  { value: 'icare', label: 'iCare Workers Compensation', agency: 'icare', kind: 'wc_48h' },
  { value: 'dcj_nsw', label: 'DCJ Child Protection', agency: 'child_protection', kind: 'child_protection' },
  { value: 'dffh_vic', label: 'DFFH Child Protection', agency: 'child_protection', kind: 'child_protection' },
  { value: 'hospital', label: 'Hospital', agency: 'hospital', kind: 'hospital' },
  { value: 'other', label: 'Other', agency: 'other', kind: 'other' },
];

export function agencyNamePresetValue(agencyName) {
  const raw = String(agencyName || '').trim();
  if (!raw) return '';
  const match = AGENCY_NAME_PRESETS.find((opt) => (
    opt.value !== 'other'
    && (opt.label.toLowerCase() === raw.toLowerCase() || opt.value === raw)
  ));
  return match ? match.value : 'other';
}

export const METHOD_LABELS = Object.fromEntries(AGENCY_METHODS.map((opt) => [opt.value, opt.label]));
export const KIND_LABELS = Object.fromEntries(AGENCY_KINDS.map((opt) => [opt.value, opt.label]));

export function injuriesFromIncident(incident) {
  if (!incident) return [];
  if (Array.isArray(incident.injuries) && incident.injuries.length) return incident.injuries;
  return incident.workers_comp?.register || [];
}

export function shouldShowInjuryStatus(injuries) {
  return Array.isArray(injuries) && injuries.length > 0;
}

export function wcStatusForInjury(row, wc = {}) {
  if (row?.near_miss) return { label: 'Near miss', tone: 'slate', filed: false };
  const notified = row?.wc_notified_at || wc?.notified_at;
  if (notified) return { label: 'Filed', tone: 'emerald', filed: true };
  const due = row?.wc_due_at || wc?.due_at;
  let overdue = !!row?.wc_overdue;
  if (!overdue && due && !notified) {
    try { overdue = new Date(due) < new Date(); } catch { overdue = false; }
  }
  if (overdue) return { label: 'Overdue', tone: 'red', filed: false };
  return { label: 'Due', tone: 'amber', filed: false };
}

export function claimNumberForInjury(row, wc = {}) {
  return row?.notification_or_claim_number || row?.wc_reference || wc?.notification_or_claim_number || '';
}

export function agenciesFrom(source) {
  if (!source) return [];
  if (Array.isArray(source.agency_notifications)) return source.agency_notifications;
  if (Array.isArray(source)) return source;
  return [];
}

export function methodLabel(method) {
  return METHOD_LABELS[method] || method || '';
}

export function filedWithMethod(filed, method) {
  const status = filed ? 'Filed' : 'Due';
  return method ? `${status} · ${methodLabel(method)}` : status;
}

export function registerRowClickAction() {
  return 'open-modal';
}

export function buildMarkFiledBody(notificationType, referenceNumber, channel) {
  const body = {
    notification_type: notificationType,
    reference_number: referenceNumber || '',
  };
  if (channel) body.channel = channel;
  return body;
}

export function wcClockOpen(wc, injuries) {
  const rows = (injuries != null ? injuries : (wc?.register || [])).filter((row) => !row.near_miss);
  return rows.length > 0 && !wc?.notified_at;
}

export function agencyGroupForKind(kind, agency) {
  if (agency) {
    const byAgency = AGENCY_GROUPS.find((group) => group.value === agency);
    if (byAgency) return byAgency;
  }
  return AGENCY_GROUPS.find((group) => group.kinds.some((opt) => opt.value === kind))
    || AGENCY_GROUPS.find((group) => group.value === 'other');
}

export function noticeTypesForAgency(agency) {
  return agencyGroupForKind(null, agency)?.kinds || [];
}

export function groupHasNoticeChoice(agency) {
  return noticeTypesForAgency(agency).length > 1;
}

export function noticeTypeLabel(kind) {
  for (const group of AGENCY_GROUPS) {
    const match = group.kinds.find((opt) => opt.value === kind);
    if (!match) continue;
    if (groupHasNoticeChoice(group.value) || group.value === 'icare') return match.label;
  }
  return '';
}

export function agencyDisplayName(row) {
  if (row?.agency_name) return row.agency_name;
  const group = agencyGroupForKind(row?.kind, row?.agency);
  return group?.label || row?.agency || 'Agency';
}

export function agencyInitials(row) {
  const name = agencyDisplayName(row);
  const parts = String(name).split(/\s+/).filter(Boolean);
  if (!parts.length) return 'AG';
  return parts.slice(0, 2).map((part) => part[0]).join('').toUpperCase();
}

export function namePresetsForAgency(agency) {
  const filtered = AGENCY_NAME_PRESETS.filter((opt) => (
    opt.value === 'other' || !agency || opt.agency === agency
  ));
  return filtered.length ? filtered : AGENCY_NAME_PRESETS;
}

export function isSuggestedAgencyRow(row) {
  if (!row) return false;
  if (row.suggested) return !row.reference && !row.notified_at;
  return !row.reference && !row.notified_at;
}

export function draftAgencyRow(kind, extras = {}) {
  const group = agencyGroupForKind(kind, extras.agency);
  const meta = AGENCY_KINDS.find((opt) => opt.value === kind);
  return {
    id: extras.id || `suggest-${kind}`,
    agency: extras.agency || meta?.agency || group?.value || 'other',
    agency_name: extras.agency_name || group?.defaultName || group?.label || '',
    kind: kind || '',
    method: extras.method || '',
    reference: extras.reference || '',
    notified_at: extras.notified_at || null,
    suggested: true,
  };
}

export function mentionsContactedAuthority(text, kind) {
  const raw = String(text || '').toLowerCase();
  if (kind === 'police') {
    return /\b(called (the )?police|police (were )?(called|notified|attended)|notified police)\b/.test(raw);
  }
  if (kind === 'ambulance') {
    return /\b(called (an |the )?ambulance|ambulance (was |were )?(called|notified|attended)|paramedics attended)\b/.test(raw);
  }
  if (kind === 'hospital') {
    return /\b(taken to (the )?hospital|admitted to hospital|hospitalis[ed]|transferred to (the )?hospital)\b/.test(raw);
  }
  return false;
}

export function mergeSuggestedAgencies(existing, suggested) {
  const rows = Array.isArray(existing) ? existing.slice() : [];
  const seen = new Set(rows.map((row) => row?.kind).filter(Boolean));
  for (const row of suggested || []) {
    if (!row?.kind || seen.has(row.kind)) continue;
    seen.add(row.kind);
    rows.push(row);
  }
  return rows;
}

export function suggestedAgenciesFromAnalyse({
  outcome,
  triage,
  incident,
  existing,
} = {}) {
  const current = agenciesFrom(existing != null ? existing : incident);
  if (outcome !== 'analyse') return current;
  const suggested = [];
  const injuries = injuriesFromIncident(incident);
  const hasClaimableInjury = injuries.some((row) => row && !row.near_miss);
  if (wcClockOpen(incident?.workers_comp, injuries) || (hasClaimableInjury && !incident?.workers_comp?.notified_at)) {
    suggested.push(draftAgencyRow('wc_48h'));
  }
  const ndis = triage?.ndis || {};
  if (ndis.is_reportable) {
    const deadline = String(ndis.deadline || '').toLowerCase();
    suggested.push(draftAgencyRow(deadline.includes('5') ? 'ndis_5day' : 'ndis_24h'));
  }
  const whs = triage?.whs || {};
  if (whs.is_notifiable) {
    suggested.push(draftAgencyRow('safework_immediate'));
    const deadline = String(whs.deadline || '').toLowerCase();
    if (deadline.includes('48') || deadline.includes('written')) {
      suggested.push(draftAgencyRow('safework_written'));
    }
  }
  const text = incident?.what_happened || '';
  if (mentionsContactedAuthority(text, 'police')) suggested.push(draftAgencyRow('police'));
  if (mentionsContactedAuthority(text, 'ambulance')) suggested.push(draftAgencyRow('ambulance'));
  if (mentionsContactedAuthority(text, 'hospital')) suggested.push(draftAgencyRow('hospital'));
  return mergeSuggestedAgencies(current, suggested);
}
